import "./index.css";
import App from "./App";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "./context/AuthProvider";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { registerServiceWorker } from "./utils/pushNotifications";
import { LayoutModeProvider } from "./layout/LayoutModeContext";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <NuqsAdapter>
    <BrowserRouter>
      <AuthProvider>
        <LayoutModeProvider>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </LayoutModeProvider>
      </AuthProvider>
    </BrowserRouter>
  </NuqsAdapter>
);


// Check that service workers are supported
if ("serviceWorker" in navigator) {
  navigator.serviceWorker.addEventListener("message", (event) => {
    const { data } = event;
    if (!data || data.type !== "NAVIGATE_TO_URL") {
      return;
    }

    const targetUrl = data.url;
    if (!targetUrl) {
      return;
    }

    if (window.location.href === targetUrl) {
      if (document.visibilityState === "hidden" && "focus" in window) {
        window.focus();
      }
      return;
    }

    window.location.href = targetUrl;
  });

  // Use the window load event to keep the page load performant
  window.addEventListener("load", () => {
    registerServiceWorker().then(
      (registration) => {
        console.log(
          "Service worker registered with scope:",
          registration.scope
        );
      },
      (error) => {
        console.log("Service worker registration failed:", error);
      }
    );
  });
}
